let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1JiyL")).then(() => parcelRequire('kA5Ep'));